// Boots the browser client: the game's content, pictures and sounds, then the login screen.
import { app } from './app';
import { api, refreshContent } from './api';
import { Sprites } from './assets';
import { Audio } from './audio';
import { useSprites } from './ui/compose';
import { LoginScreen, enterWorlds } from './screens/menus';
import { completeSignIn } from './client/supabaseLogin';
import { game } from './client/game';
import { config, loadConfig } from './config';
import { assetUrl } from './assetUrl';
import { installClientUpdates } from './clientUpdate';

const status = document.getElementById('boot-status')!;
const setStatus = (text: string) => { status.textContent = text; };

async function boot(): Promise<void> {
  setStatus('Starting...');
  await loadConfig();
  // Consume auth callbacks before loading assets; never leave a single-use code in the URL.
  let authError: string | null = null;
  let authToken: string | null = null;
  try { authToken = await completeSignIn(config.supabase); }
  catch (e) { authError = (e as Error).message; }

  setStatus('Loading the world\'s rules...');
  const manifest = await (await fetch(assetUrl('Content/manifest.json'))).json() as { data: string[]; sprites: string[]; audio: string[]; tilesets?: string[] };
  const texts = await Promise.all(manifest.data.map(async f => (await fetch(assetUrl(f))).text()));
  const init = await api.init(manifest.data, texts);
  for (const p of init.problems) console.warn('Content:', p);
  refreshContent();

  const sprites = await Sprites.load(manifest.sprites, setStatus, manifest.tilesets ?? []);
  app.sprites = sprites;
  useSprites(sprites);
  app.audio = new Audio(manifest.audio);
  await Promise.all([400, 500, 600].map(w => document.fonts.load(`${w} 14px 'Fira Sans'`)));

  await app.init(document.getElementById('stage')!);
  installClientUpdates();
  document.getElementById('boot')!.classList.add('hidden');
  // A sign-in redirect goes on to the world list (or the only world).
  if (authToken) enterWorlds(false, authToken);
  else app.show(new LoginScreen(authError));
  // For the browser console and automated checks (the server decides everything anyway).
  (globalThis as any).ashenheart = { api, app, ui: app.ui, game };
}

boot().catch(e => {
  console.error(e, e?.stack);
  setStatus(`Could not start the game: ${e?.message ?? e}`);
});
